import type { TOC } from '@ember/component/template-only';
import t from 'ember-intl/helpers/t';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}
export default <template>
  <@form.NumberInput
    @propertyName='weight'
    @labelName={{t 'mici-form.weight.long' htmlSafe=true}}
    @min='1'
    @max='200'
  />
</template> satisfies TOC<Signature>;
